<template>
    <v-row class="mt-2">
        <v-col cols="12" class="d-flex">
            <div class="title font-weight-medium g5--text mb-5">{{ $t('History') }}</div>
        </v-col>
        <EmailLog
            v-for="(emailLog, index) in emailLogs"
            :key="index"
            :email-log="emailLog"
            :is-last-of-list="index === emailLogs.length - 1"
            :show-project-type="showProjectType"
            @select-email-log="selectedEmailLogId = $event"
            @update-pin="$emit('update-pin', $event)"
            @reload="$emit('reload')"
        />
        <EmailLogDialog
            v-if="selectedEmailLog && selectedEmailLog.type === 'email_log'"
            :client-id="clientId"
            :email-log-id="selectedEmailLogId"
            @close="selectedEmailLogId = null"
        />
        <IncomingEmailDialog
            v-if="selectedEmailLog && selectedEmailLog.type !== 'email_log'"
            :task-log="selectedEmailLog"
            @close="selectedEmailLogId = null"
        />
    </v-row>
</template>

<script>
import {ref, computed, watch} from "@vue/composition-api";
import EmailLogDialog from "@/components/Emailing/EmailLogDialog/Index.vue";
import IncomingEmailDialog from "@/components/Emailing/IncomingEmailDialog/Index.vue"
import EmailLog from "@/views/Client/Communication/History/EmailLog";
import { Router } from "@/composables/Router";

export default {
    name: "CommunicationHistory",
    components: {
        EmailLogDialog,
        EmailLog,
        IncomingEmailDialog
    },
    props: {
        emailLogs: {
            type: Array,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        },
        showProjectType: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const router = Router();
        const selectedEmailLogId = ref(null);

        const selectedEmailLog = computed(() => {
            return props.emailLogs.find(x => x.id === selectedEmailLogId.value)
        })

        const openEmailLogFromQuery = () => {
            let emailLogId = router.currentRoute.query.email_log_id
            if (!emailLogId) {
                return
            }

            if (!props.emailLogs.find(x => x.id === emailLogId)) {
                return
            }

            selectedEmailLogId.value = emailLogId
        }

        watch (() => props.emailLogs, () => {
            openEmailLogFromQuery()
        }, { immediate: true })

        watch (() => ctx.root._route.query, () => {
            openEmailLogFromQuery()
        }, { immediate: true })

        return {
            selectedEmailLogId,
            selectedEmailLog,
        }
    }
};
</script>
